import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";

import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';
import { Compania } from '../Models/Compania';
import { Motivo } from '../Models/Motivo';
@Injectable()

export class MotivoService {

  
  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }


    /**
     * Obtiene todos los motivos de la compañia
     * @param compania 
     */
    ObtenerMotivos(compania: string): Observable<Motivo[]> {

      try {
  
        let url = this._utiles.getURL("Motivo/" + compania);
  
  
        return this._http.get(url).map((response: Response) => {
          return <Motivo[]>response.json();
        });
  
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }


    /**
     * Obtiene un motivo por el id
     * @param compania 
     * @param idMotivo 
     */
    ObtenerMotivo(compania: string, idMotivo: string): Observable<Motivo> {

      try {
  
        let url = this._utiles.getURL("Motivo/" + compania + '/' + idMotivo);
  
  
        return this._http.get(url).map((response: Response) => {
          return <Motivo>response.json();
        });
  
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }


    /**
     * Inserta o actualiza el motivo dependiendo de la situacion
     * @param motivo 
     */
    public GuardarRegistroMotivo(motivo: Motivo) {

      try {
  
        let params = JSON.stringify(motivo);
  
        let url = this._utiles.getURL("Motivo/");
  
        let headers = new Headers({ 'Content-Type': 'application/json' });
  
  
        let data: any;
  
        return this._http.post(url, motivo, {headers: headers}).map(res => res.json());
  
      } catch (error) {
        console.log(error);
      }
  
  
    }

}
